// src/identity.js
import netlifyIdentity from "netlify-identity-widget";

// initialize once per app (prevents flicker & stale state)
if (typeof window !== "undefined" && !window.__nb_id_init__) {
  window.__nb_id_init__ = true;
  netlifyIdentity.init({ autologin: false });
}

export default netlifyIdentity;
